export const isScrollBehaviorSupported = () =>
  'scrollBehavior' in document.documentElement.style;

export const windowScrollTo = (options: {
  top: number;
  left: number;
  behavior: ScrollBehavior;
}) => {
  if (isScrollBehaviorSupported()) {
    return window.scrollTo(options);
  }

  return window.scrollTo(options.top, options.left);
};
